const scheduleDaySlugs = ['day-1', 'day-2', 'day-3', 'day-4', 'day-5'];

export { scheduleDaySlugs };
